export const PROCUREMENT_METHOD: Record<string, Record<string, string>| string> = {
    "open": "про проведення відкритих торгів",
    "belowThreshold": "про проведення спрощеної/допорогової закупівлі",
    "limited": "Переговорна процедура",
};
